import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import React from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuPosition } from 'ui-components/components/INTERNAL/dropdown/dropdown-menu-position';

import messages from './messages';

import style from './label-details.module.less';

export const LabelActionsDropdownMenu = ({ actionMenuItems }) => {
  const { formatMessage } = useIntl();

  return (
    <DropdownMenu className={style['label-actions-dropdown-menu']} menuPosition={DropdownMenuPosition.BottomRight}>
      <DropdownMenuToggler ariaLabel={formatMessage(messages.labelActionsDropdownMenuAriaLabel)} hideChevron theme='unstyled'>
        <FontAwesomeIcon className={style['label-actions-button-icon']} icon={faEllipsisH} />
      </DropdownMenuToggler>
      {actionMenuItems}
    </DropdownMenu>
  );
};

LabelActionsDropdownMenu.propTypes = {
  actionMenuItems: PropTypes.node.isRequired,
};
